import Icon from "@client/controls/Icon/component";
import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { getTourAttributes } from "@common/contexts/Tour";
import { type PositionType } from "@common/controls/Tooltip/lib";
import classnames from "classnames";
import * as React from "react";
import "./style.less";

export interface ButtonProps {
  className?: string;
  tourStep?: string;
  isDisabled?: boolean;
  iconClassName?: any;
  isIconAfter?: boolean;
  isBusy?: boolean;
  onClick?: React.MouseEventHandler;
  ref?: React.RefObject<HTMLButtonElement | null>;
  style?: React.CSSProperties;
  tooltip?: string | null;
  tooltipPosition?: PositionType;
  type?: "button" | "submit";
  children?: any;
}

const Button = (props: ButtonProps) => {
  return (
    <button
      ref={props.ref}
      className={classnames("wsc_btn btn", props.className, { disabled: props.isDisabled || props.isBusy })}
      onClick={(e) => (props.isDisabled || props.isBusy || !props.onClick ? undefined : props.onClick(e))}
      style={props.style}
      type={props.type ?? "button"}
      {...getTooltipAttributes(props.tooltip)}
      {...getTourAttributes({ step: props.tourStep })}
    >
      {props.isBusy && "Please wait..."}
      {!props.isBusy && !!props.iconClassName && !props.isIconAfter && <Icon iconClassName={props.iconClassName} />}
      {!props.isBusy ? (
        typeof props.children === "string" ? (
          <span className="caption">{props.children}</span>
        ) : (
          props.children
        )
      ) : null}
      {!props.isBusy && !!props.iconClassName && props.isIconAfter && <Icon iconClassName={props.iconClassName} />}
    </button>
  );
};

export default Button;
